import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/CRMit_logo_Dark.png";
import LogoDarkCRMit from "../assets/images/CRMit_logo_Dark.png";
import logoLight from "../assets/images/CRMit_logo_Light.png";
import LogoLightCRMit from "../assets/images/CRMit_logo_Light.png";

//import Components
import SearchOption, {
  SearchOptionMobile,
} from "../Components/Common/SearchOption";
import LanguageDropdown from "../Components/Common/LanguageDropdown";
import WebAppsDropdown from "../Components/Common/WebAppsDropdown";
import MyCartDropdown from "../Components/Common/MyCartDropdown";
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import NotificationDropdown from "../Components/Common/NotificationDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import LightDark from "../Components/Common/LightDark";
import TimeTrackingDropdown from "../Components/Common/TimeTrackingDropdown";
import MyShortCuts from "../Components/MyShortCuts/MyShortCuts";
import { isEmpty } from "lodash";
import ClickOutside from "../Components/Common/ClickOutsideComponent";
import { useSelector } from "react-redux";
import controlPanelReducer from "../store/ControlPanel/reducer";
import { isDeveloperUser } from "../helpers/functions/developerFlag";

// Task 24789 - the CRMit dev queue. Change #100002: the queue moved out of the
// company 3 task list into ZCRM_Master (Settings > Super Admin > System Changes,
// Task 24912), which every tenant can reach, so this is an in-app path now.
const CRM_DEV_QUEUE_URL = "/settings/3/19";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };
  const CompanyData = JSON.parse(
    localStorage.getItem("authUser")
  )?.get_company_data;

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical menu
    if (document.documentElement.getAttribute("data-layout") === "vertical") {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.toggle("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };
  // get authUser from local storage
  const authUser = JSON.parse(localStorage.getItem("authUser"))
    ?.get_company_data?.Company_LogoUrl;
  const [darkLogo, setDarkLogo] = useState([authUser]);

  useEffect(() => {
    if (authUser) {
      setDarkLogo(authUser);
    }
  }, [JSON.parse(localStorage.getItem("authUser"))]);
  const getLocalActiveCompanyId = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.Company_IdExternal;

  const [windowsWidth, setWindowsWidth] = React.useState(window.innerWidth);

  // Task 24789 - read once per render from localStorage, the same way every
  // other FlagDeveloper gate in the app does.
  const isDeveloper = isDeveloperUser();
  return (
    <React.Fragment>

        <header
          id="page-topbar"
          className={headerClass}
          style={
            windowsWidth < 750 &&
            getLocalActiveCompanyId === "comp_HEiCe0JxpAXPjVisFwNwKsUSWZ4obmwG"
              ? { marginTop: "30px" }
              : {}
          }
        >
          {/*<ClickOutside*/}
          {/*    onClick={() => {*/}
          {/*    // todo*/}
          {/*    }}*/}
          {/*></ClickOutside>*/}
          <div className="layout-width">
            <div className="navbar-header">
              <div className="d-flex align-items-center">
                <div className="navbar-brand-box horizontal-logo">
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={darkLogo} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                      <img src={darkLogo} alt="" height="40" />
                    </span>
                  </Link>

                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={LogoLightCRMit} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                      <img src={LogoLightCRMit} alt="" height={"40"} />
                    </span>
                  </Link>
                </div>

                <button
                  onClick={toogleMenuBtn}
                  type="button"
                  className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                  id="topnav-hamburger-icon"
                >
                  <span className="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
                {document.documentElement.clientWidth < 750 && (
                  <div>
                    <span className="logo-sm">
                      <img src={darkLogo} alt="" height="22" />
                    </span>
                  </div>
                )}

                {!isEmpty(CompanyData) && <SearchOption />}
              </div>
              <div className="d-flex align-items-center">
                {!isEmpty(CompanyData) && <SearchOptionMobile />}
                {!isEmpty(CompanyData) && <TimeTrackingDropdown />}

                {/* LanguageDropdown */}
                {/*<LanguageDropdown />*/}
                {!isEmpty(CompanyData) && <MyShortCuts />}

                {/* Task 24789 - straight to the CRMit dev queue, in a new tab
                    so whatever the developer was doing in this tenant is left
                    where it was. Desktop only (the same > 767 gate the web-apps
                    dropdown uses - the header has no room for it on a phone)
                    and only for User.FlagDeveloper = 1, so it is invisible to
                    every customer. */}
                {windowsWidth > 767 && isDeveloper && !isEmpty(CompanyData) && (
                  <a
                    href={CRM_DEV_QUEUE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open the CRMit dev queue in a new tab"
                    className="btn btn-sm btn-soft-primary text-nowrap me-2"
                  >
                    <i className="ri-terminal-box-line align-middle me-1"></i>
                    CRM Dev Queue
                  </a>
                )}

                {/* WebAppsDropdown */}
                {windowsWidth > 767 && <WebAppsDropdown />}

                {/* MyCartDropdwon */}
                {/*<MyCartDropdown />*/}

                {/* FullScreenDropdown */}
                {/*<FullScreenDropdown />*/}

                {/*/!* Dark/Light Mode set *!/*/}
                {/*<LightDark*/}
                {/*  layoutMode={layoutModeType}*/}
                {/*  onChangeLayoutMode={onChangeLayoutMode}*/}
                {/*/>*/}

                {/* NotificationDropdown */}
                {!isEmpty(CompanyData) && <NotificationDropdown />}

                {/* ProfileDropdown */}
                <ProfileDropdown />
              </div>
            </div>
          </div>
        </header>

    </React.Fragment>
  );
};

export default Header;
